import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=6b9c2fb8&scoped=true"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=6b9c2fb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c2fb8",
  null
  
)

export default component.exports